import { IAppState } from '../common/state';
import { IRecommendedVillages } from '../types/recommendedVillages';

export const selectRecommendedVillages = (state: IAppState): IRecommendedVillages | null => {
  return state.recommendedVillages;
};
